import { githubHandle } from '@/lib/utils';
import type { MentorDashboardsShow } from '@/types';

// /:event_slug/mentor/dashboard — the 26-co and 26-mx twins as one page (PORTING.md G5).
// The two Next files are byte-identical apart from the edition they name, which is now
// the `eventName` prop.

function githubUrl(github: string | null): string | null {
  const handle = githubHandle(github);
  return handle ? `https://github.com/${handle}` : null;
}

export default function Show({ dashboard, eventName }: MentorDashboardsShow) {
  const firstName = dashboard.mentor.fullName.split(' ')[0];

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="mx-auto w-full max-w-4xl space-y-8">
          <div className="text-center">
            <h1 className="inline-block font-bold font-title text-2xl text-primary sm:text-3xl md:text-4xl">
              Hola,{' '}
              <span className="bg-primary px-2 py-1 text-background">
                {firstName}
              </span>
            </h1>
            {eventName && (
              <p className="mt-4 font-mono text-primary/70 text-sm">
                Mentor en {eventName}
              </p>
            )}
          </div>

          <div className="border-2 border-primary bg-background/80 p-6 backdrop-blur-sm sm:p-8 md:p-10">
            <div className="border-primary/20 border-b pb-4">
              <h2 className="font-bold font-title text-2xl text-primary sm:text-3xl md:text-4xl">
                TUS EQUIPOS
              </h2>
              <p className="mt-2 font-mono text-primary/70 text-sm">
                {dashboard.teams.length === 0
                  ? 'Aún no tienes equipos asignados.'
                  : `${dashboard.teams.length} ${
                      dashboard.teams.length === 1
                        ? 'equipo asignado'
                        : 'equipos asignados'
                    }`}
              </p>
            </div>

            {dashboard.teams.length > 0 && (
              <div className="mt-6 space-y-6">
                {dashboard.teams.map((team) => (
                  <div
                    key={team.id}
                    className="border-2 border-primary/30 bg-background p-5"
                  >
                    <div className="flex flex-col gap-2 border-primary/20 border-b pb-4 sm:flex-row sm:items-center sm:justify-between">
                      <h3 className="font-bold font-title text-primary text-xl sm:text-2xl">
                        {team.slug}
                      </h3>
                      <div className="flex flex-wrap items-center gap-2">
                        {team.tableNumber && (
                          <span className="font-title text-primary/70 text-sm">
                            Mesa:{' '}
                            <span className="bg-primary px-2 py-1 font-bold text-background">
                              {team.tableNumber}
                            </span>
                          </span>
                        )}
                        {team.track && (
                          <span className="font-title text-primary/70 text-sm">
                            Track:{' '}
                            <span className="bg-primary px-2 py-1 font-bold text-background">
                              {team.track.name}
                            </span>
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="mt-4 space-y-2">
                      {team.members.map((member) => {
                        const url = githubUrl(member.github);
                        return (
                          <div
                            key={member.id}
                            className="flex flex-col border-primary border-l-4 pl-4 sm:flex-row sm:items-center sm:justify-between"
                          >
                            <span className="font-bold font-title text-base text-primary sm:text-lg">
                              {member.fullName}
                            </span>
                            {url && (
                              <a
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-mono text-primary/70 text-sm transition-colors hover:text-primary hover:underline"
                              >
                                {githubHandle(member.github)}
                              </a>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
